<template>
    <div class="row">
        <div class="col-12">
            <FormInput placeholder="Buscar..." v-model="search" />
        </div>
        <div class="col-12 tabla-sectores">
            <div class="table-responsive">
                <table class="table table-hover text-nowrap">
                    <thead>
                        <tr>
                            <th></th>
                            <th>{{ $t('general.sector') }}</th>
                        </tr>
                    </thead>
                    <tbody v-if="zonas">
                        <tr
                            v-for="(zona, index) in search_zonas" 
                            :key="index"
                            @click="goTo(2, zona)"
                        >
                            <td v-if="mostrarZona(zona)" :style='"background-color: " + zona.color'></td>
                            <td v-if="mostrarZona(zona)">{{ zona.name }}</td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="4">
                                <LoaderComponent/>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['zonas'],
        data() {
            return {
                search: ''
            }
        },
        computed: {
            search_zonas : function() {
                var zonas = [];
            
                this.zonas.forEach(zona => {
                    if(zona.esta_disponible || this.superAdmin) {
                        if(zona.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1) {
                            zonas.push(zona);
                        }
                    }
                });

                return zonas;
            },
            user() {
                return this.$store.getters.getUser;
            },
            superAdmin() {
                var path = this.$router.currentRoute.fullPath;

                return path.includes('superadmin');
            }
        },
        methods: {
            goTo(paso, zona) {
                this.$emit('goTo', paso, zona);
            },
            mostrarZona(zona) {
                return this.user.role != 11 || (this.user.regions.some(objeto => objeto.id === Number(zona.id)));
            }
        },
    }
</script>

<style>
    .tabla-sectores {
        overflow: scroll;
        height: 400px;
    }

    @media (max-width: 768px) {
        .tabla-sectores {
            height: fit-content;
            margin-bottom: 0px;
        }
    }
</style>
